import Badge from './Badge.jsx';
import {
  STATUS_LABELS, STATUS_TONE, PRIORITY_LABELS, TIER_TONE, TIER_LABEL, initialsFor
} from '../lib/tickets.js';

// Status badge — open=amber, in_progress=teal, waiting/closed=grey.
export function TicketStatusBadge({ value }) {
  if (!value) return null;
  return <Badge tone={STATUS_TONE[value] || 'grey'}>{STATUS_LABELS[value] || value}</Badge>;
}

// Priority badge — high=red, low=grey. Normal renders nothing (callers
// show a mono "—") to keep the common case visually quiet.
export function TicketPriorityBadge({ value }) {
  if (value === 'high') return <Badge tone="red">{PRIORITY_LABELS.high}</Badge>;
  if (value === 'low')  return <Badge tone="grey">{PRIORITY_LABELS.low}</Badge>;
  return null;
}

export function RenewalTierBadge({ tier }) {
  if (!tier) return null;
  return <Badge tone={TIER_TONE[tier] || 'grey'}>{TIER_LABEL[tier] || tier}</Badge>;
}

// Coloured left bar used in the tickets list first column.
export function StatusBar({ status }) {
  return <span className={`ticket-status-bar ticket-status-bar-${status || 'open'}`} aria-hidden="true" />;
}

// Round initials chip. size in px.
export function InitialsAvatar({ user, size = 22 }) {
  return (
    <span
      className="ticket-avatar"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.42) }}
      title={user?.name || user?.email || ''}
    >
      {initialsFor(user)}
    </span>
  );
}

// Primary + overflow collaborators as an avatar + name + "+N" pill.
export function AssigneeCell({ ticket }) {
  const primary = ticket.primaryAssignee;
  const collabs = ticket.collaborators || [];
  if (!primary && collabs.length === 0) {
    return <span className="cell-mono cell-muted">Unassigned</span>;
  }
  const lead = primary || collabs[0].user;
  const extras = (primary ? collabs : collabs.slice(1)).filter((c) => c.user.id !== lead.id);
  const extraNames = extras.map((c) => c.user.name || c.user.email).join(', ');
  return (
    <span className="ticket-assignee">
      <InitialsAvatar user={lead} />
      <span className="ticket-assignee-name">
        {lead.name || lead.email}
        {!primary && <span className="cell-mono cell-muted"> (collab)</span>}
      </span>
      {extras.length > 0 && (
        <span className="ticket-extra-pill" title={extraNames}>+{extras.length}</span>
      )}
    </span>
  );
}
